module.exports = __webpack_public_path__ + "img/bg.a7cf1ef0.png";